import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { makeRowColumn, getHeadObj, dayColor } from 'lib/commonLib';
import { mediaCtrStatistics } from 'lib/api/media';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const MediaFlucAmtStatistics = () => {
  const [initialization, setInitialization] = useState(false);
  const initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    type: 'advrtsAmt',
    pltfomTpCode: 'all',
  };
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    setInitialization(false);
  }, [params]);

  const customized = {
    SPNAME: {
      merged: true,
    },
    '1DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-1, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '1DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['1DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['1DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '2DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-2, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '2DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['2DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['2DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '3DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-3, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '3DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['3DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['3DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '4DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-4, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '4DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['4DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['4DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '5DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-5, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '5DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['5DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['5DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '6DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-6, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '6DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['6DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['6DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '7DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-7, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '7DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['7DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['7DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '8DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-8, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '8DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['8DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['8DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '9DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-9, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '9DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['9DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['9DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
    '10DAY_ADVRTS_AMT': {
      makeHead: (headsMap) => {
        const DAY_LAVEL = moment().add(-10, 'day');
        return dayColor(DAY_LAVEL, 'date', 'MM-DD');
      },
      makeBody: (rowObj, headsMap) => {
        const day = getHeadObj(headsMap, '10DAY_ADVRTS_AMT');
        return (
          <span title={rowObj['10DAY_ADVRTS_AMT']}>
            {makeRowColumn(rowObj['10DAY_ADVRTS_AMT'], day.type, day.format)}
          </span>
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDate={false}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={mediaCtrStatistics}
        params={params}
        customized={customized}
        getParam={getParam}
      />
    </>
  );
};
export default withRouter(MediaFlucAmtStatistics);
